<template>
    <div id="scroll" class="sec-main scroll" @wheel="wheelMotion">
        
        <div class="slide-left" v-if="pageNow > 1" @click="pageTarget--; wheelMotionMotion()"></div>
        <div class="slide-right" v-if="pageNow < pageTotal" @click="pageTarget++; wheelMotionMotion()"></div>

        <section v-on:keyup="mainHandler()">
            <div class="page section-1" id="sec1" @wheel="wheelMotion" 
                :class="{
                    'white': mainSlide == 1 ||  mainSlide == 4 || mainSlide == 5 
                }">
                <div id="page-shadow" class="page-shadow"></div>
                <div id="page-outline" class="page-outline">
                    <div id="typography-we-are" class="typography-we-are">
                        <label class="ani-1">WE ARE</label>
                        <div class="ani_text" :class="'ani_' + mainSlide">
                            <div class="sec sec_1" :class="{'on': mainSlide == 1, 'prev': prevSlide == 1}">
                                <div class="txt"><h1 class="ani-1">creative</h1></div>
                                <div class="txt"><h1 class="ani-2">problem</h1></div>
                                <div class="txt"><h1 class="ani-3">solvers</h1></div>
                            </div>
                            <div class="sec sec_2" :class="{'on': mainSlide == 2, 'prev': prevSlide == 2}">
                                <div class="txt"><h1 class="ani-1">brand</h1></div>
                                <div class="txt"><h1 class="ani-2">gurus</h1></div>
                            </div>
                            <div class="sec sec_3" :class="{'on': mainSlide == 3, 'prev': prevSlide == 3}">
                                <div class="txt"><h1 class="ani-1">motion</h1></div>
                                <div class="txt"><h1 class="ani-2">mavens</h1></div>
                            </div>
                            <div class="sec sec_4" :class="{'on': mainSlide == 4, 'prev': prevSlide == 4}">
                                <div class="txt"><h1 class="ani-1">style</h1></div>
                                <div class="txt"><h1 class="ani-2">forcasters</h1></div>
                            </div>
                            <div class="sec sec_5" :class="{'on': mainSlide == 5, 'prev': prevSlide == 5}">
                                <div class="txt"><h1 class="ani-1">packaging</h1></div>
                                <div class="txt"><h1 class="ani-2">enthusiasts</h1></div>
                            </div>
                            
                        </div>
                        <div class="divider"></div>
                        <h2>At CMYK+WHITE, we design to transform, <br>motivate, delight and provoke.</h2>
                    </div>

                    <div class="pageing d-flex align-items-center">
                        <span>{{ mainSlide }}</span> <span id="page_spin" class="spin"><em>/</em></span> <span class="total_pg">5</span>

                        <div class="arrow ml-4" @click="mainHandlerMotion('left')">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20" height="20" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                                <polyline style="fill:none;stroke:#333;stroke-miterlimit:10;" points="13.5,1.5 5.5,9.5 13.5,17.5 "/>
                            </svg>
                        </div>
                        <div class="arrow ml-2" @click="mainHandlerMotion('right')">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20" height="20" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                                <polyline style="fill:none;stroke:#333;stroke-miterlimit:10;" points="6.5,1.5 14.5,9.5 6.5,17.5 "/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div id="project" class="project">
                    <carousel ref="carousel"
                            :navigateTo="slideIdx" 
                            :perPage="1" 
                            :paginationEnabled="false" 
                            @page-change="slideChange()" 
                            @transition-start="slideStart()" 
                            @transition-end="slideEnd()">
                        <slide>
                            <div class="typography-we-are sec_1">
                                <div class="mainText-mobile">
                                    <label class="ani-1">WE ARE</label>
                                    <div class="sec">
                                        <div class="txt"><h1 class="ani-1">creative</h1></div>
                                        <div class="txt"><h1 class="ani-2">problem</h1></div>
                                        <div class="txt"><h1 class="ani-3">solvers</h1></div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <h2>At CMYK+WHITE, we design to transform, motivate, delight and provoke.</h2>
                            </div>

                            <video autoplay loop muted playsinline poster="https://cmykpluswhite.s3.amazonaws.com/Website_Images/video_1.jpg">
                                <source id="main_video_1" src="https://player.vimeo.com/external/436237913.hd.mp4?s=a6a965e11f2d4e37b4a3e5341ea7ddbd004af8b8&profile_id=175" type="video/mp4">
                            </video>
                        </slide>

                        <slide>
                            <div class="typography-we-are sec_2">
                                <div class="mainText-mobile">
                                    <label class="ani-1">WE ARE</label>
                                    <div class="sec">
                                        <div class="txt"><h1 class="ani-1">brand</h1></div>
                                        <div class="txt"><h1 class="ani-2">gurus</h1></div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <h2>At CMYK+WHITE, we design to transform, motivate, delight and provoke.</h2>
                            </div>

                            <div class="sec_2_img"></div>
                        </slide>

                        <slide>
                            <div class="typography-we-are sec_3">
                                <div class="mainText-mobile">
                                    <label class="ani-1">WE ARE</label>
                                    <div class="sec sec_3">
                                        <div class="txt"><h1 class="ani-1">motion</h1></div>
                                        <div class="txt"><h1 class="ani-2">mavens</h1></div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <h2>At CMYK+WHITE, we design to transform, motivate, delight and provoke.</h2>
                            </div>

                            <video autoplay loop muted playsinline poster="https://cmykpluswhite.s3.amazonaws.com/Website_Images/video_3.jpg">
                                <source id="main_video_3" src="https://player.vimeo.com/external/436813240.hd.mp4?s=8de655af55ab19b6c5aced873ba0d1ebfa6c9586&profile_id=175" type="video/mp4">
                            </video>
                        </slide>

                        <slide>
                            <div class="typography-we-are sec_4">
                                <div class="mainText-mobile">
                                    <label class="ani-1">WE ARE</label>
                                    <div class="sec sec_4">
                                        <div class="txt"><h1 class="ani-1">style</h1></div>
                                        <div class="txt"><h1 class="ani-2">forcasters</h1></div>
                                    </div>
                                </div>    
                                <div class="divider"></div>
                                <h2>At CMYK+WHITE, we design to transform, motivate, delight and provoke.</h2>
                            </div>

                            <video autoplay loop muted playsinline poster="https://cmykpluswhite.s3.amazonaws.com/Website_Images/video_4.jpg">
                                <source id="main_video_4" src="https://cmykpluswhite.s3.amazonaws.com/video/Diorosaur_1920_1080.mp4" type="video/mp4">
                            </video>
                            
                        </slide>

                        <slide>
                            <div class="typography-we-are sec_5">
                                <div class="mainText-mobile">
                                    <label class="ani-1">WE ARE</label>
                                    <div class="sec sec_5">
                                        <div class="txt"><h1 class="ani-1">packaging</h1></div>
                                        <div class="txt"><h1 class="ani-2">enthusiasts</h1></div>
                                    </div>
                                </div>
                                <div class="divider"></div>
                                <h2>At CMYK+WHITE, we design to transform, motivate, delight and provoke.</h2>
                            </div>

                            <video autoplay loop muted playsinline poster="https://cmykpluswhite.s3.amazonaws.com/Website_Images/video_5.jpg">
                                <source id="main_video_5" src="https://player.vimeo.com/progressive_redirect/playback/855949724/rendition/1080p/file.mp4?loc=external&signature=20f7973da209daf06d6c5036e288c59d97d4f191799d56ad67c179647528fc36" type="video/mp4">
                            </video>
                        </slide>
                    </carousel>

                    <div class="pageing d-flex align-items-center">
                        <span>{{ mainSlide }}</span> <span id="page_spin" class="spin"><em>/</em></span> <span class="total_pg">5</span>

                        <div class="arrow ml-4" @click="mainHandlerMotion('left')">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20" height="20" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                                <polyline style="fill:none;stroke:#333;stroke-miterlimit:10;" points="13.5,1.5 5.5,9.5 13.5,17.5 "/>
                            </svg>
                        </div>
                        <div class="arrow ml-2" @click="mainHandlerMotion('right')">
                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="20" height="20" viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                                <polyline style="fill:none;stroke:#333;stroke-miterlimit:10;" points="6.5,1.5 14.5,9.5 6.5,17.5 "/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="page section-2" id="sec2" @wheel="wheelMotion">
                <div class="page-outline">
                    <div class="typography-at-cmyk">
                        <svg version="1.1" id="black" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 475.456 55.83" style="enable-background:new 0 0 475.456 55.83;" xml:space="preserve">
                            <polygon points="245.573,2.786 234.404,2.786 234.404,22.331 214.863,22.331 214.863,33.498 234.404,33.498 234.404,53.039 245.573,53.039 245.573,33.498 265.106,33.498 265.106,22.331 245.573,22.331"/>
                            <polygon points="475.456,13.954 475.456,2.786 447.547,2.786 447.547,53.039 475.456,53.039 475.456,41.875 458.711,41.875 458.711,33.498 475.456,33.498 475.456,22.331 458.711,22.331 458.711,13.954"/>
                            <polygon points="368.14,22.331 351.387,22.331 351.387,2.786 340.231,2.786 340.231,53.039 351.387,53.039 351.387,33.498 368.14,33.498 368.14,53.039 379.312,53.039 379.312,2.786 368.14,2.786"/>
                            <rect x="390.476" y="2.786" width="11.164" height="50.253"/>
                            <polygon points="407.843,2.786 407.843,13.954 419.015,13.954 419.015,53.039 430.171,53.039 430.171,13.954 441.343,13.954 441.343,2.786"/>
                            <polygon points="313.396,36.451 305.625,2.786 305.286,2.786 295.665,2.786 295.326,2.786 287.555,36.451 278.532,2.786 266.972,2.786 280.438,53.039 293.686,53.039 300.471,23.627 307.257,53.039 320.505,53.039 333.971,2.786 322.419,2.786"/>
                            <path d="M27.917,11.163c7.294,0,13.482,4.665,15.78,11.168h11.588C52.696,9.588,41.431,0,27.917,0C12.504,0,0,12.497,0,27.913C0,43.33,12.505,55.83,27.917,55.83c13.514,0,24.779-9.592,27.368-22.331H43.697c-2.298,6.503-8.486,11.168-15.78,11.168c-9.25,0-16.738-7.504-16.738-16.754C11.18,18.663,18.668,11.163,27.917,11.163z"/>
                            <polygon points="148.527,21.325 138.85,3.109 126.2,3.109 142.953,34.621 142.953,53.039 154.117,53.039 154.117,34.609 170.871,3.109 158.22,3.109"/>
                            <polygon points="215.017,2.786 201.389,2.786 188.238,21.567 188.238,2.786 177.067,2.786 177.067,53.039 188.238,53.039 188.238,32.638 202.512,53.039 216.156,53.039 197.996,27.101"/>
                            <polygon points="101.408,2.786 92.127,36.083 82.853,2.786 64.21,2.786 64.21,53.039 75.381,53.039 75.381,11.64 86.909,53.039 87.417,53.039 96.86,53.039 97.361,53.039 108.889,11.64 108.889,53.039 120.044,53.039 120.044,2.786"/>
                        </svg>
                        is <br>a multidisciplinary<br>design studio.

                        <div id="section-2-desc" class="desc">We create focusing on creating solutions for a range of clients across beauty, experiences, interiors, fashion and more. Our goal is to serve your design needs across all platforms in order to create a consistently branded message. We are creative explorers dedicated to letting the problem direct a solution that is engaging, genuine and innovative. Our simple design philosophy reflects our desire to build brands that cut through the clutter.</div>
                    </div>
                </div>
                <div class="page-bg">
                    <video autoplay loop muted playsinline>
                        <source src="https://player.vimeo.com/progressive_redirect/playback/753685930/rendition/720p/file.mp4?loc=external&signature=d3b2bd7ad2bc45655e51d3200f71aba2ec0c94eb0b19e35673f72dd93511f57d" type="video/mp4">
                    </video>
                </div>
            </div>
        </section>

        <section>
            <div class="page timepage section-3" id="sec3" @wheel="wheelMotion">
                <div class="page-outline">
                    <div class="typography-timeline page-title" :class="'target-' + pageTarget + ' now-' + pageNow ">Our Story</div>

                    <div class="timeline">
                        <div class="line"></div>
                        <div class="desc desc1">
                            <div class="date">The beginning</div>
                            <div class="txt">In 2003 our two visionary founders,<br> EunSun and Yongsin established CMYK+WHITE.</div>
                            <div class="pic">
                                <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/1_FPO.jpg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="page timepage section-4" id="sec4" @wheel="wheelMotion">
                <div class="page-outline">

                    <div class="timeline">
                        <div class="line"></div>
                        <div class="desc">
                            <div class="date">Expansion</div>
                            <div class="txt">In 2007 our cross-functional design team started growing and<br> we moved into our first NYC office space.</div>
                            <div class="pic">
                                <video autoplay loop muted playsinline>
                                    <source src="https://player.vimeo.com/external/436127872.sd.mp4?s=a9805b56e1304fb70dc2aaa4a1b86fc6dda99aa4&profile_id=164" type="video/mp4">
                                </video>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="page timepage section-5" id="sec5" @wheel="wheelMotion">
                <div class="page-outline">

                    <div class="timeline">
                        <div class="line"></div>
                        <div class="desc">
                            <div class="date">Now</div>
                            <div class="txt">We specialize in creating comprehensive <br> design solutions for our clients. The work we design encompasses <br>brand identity, strategy, packaging and experience design.</div>
                            <div class="pic">
                                <img src="https://cmykpluswhite.s3.amazonaws.com/Website_Images/3.jpg" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section>
            <div class="page timepage section-6" id="sec6" @wheel="wheelMotion">
                <div class="page-outline">

                    <div class="timeline">
                        <div class="line line1" :class="{'on' : pageTarget == 6}"></div>
                        <div class="desc desc2">
                            <div class="date">Future</div>
                            <div class="txt">CMYK+WHITE, will continue growing as a creative force in<br> the design industry and integrating new technologies into<br> everything we produce.</div>
                            <div class="pic">
                                <video autoplay loop muted playsinline>
                                    <source src="https://player.vimeo.com/external/436244778.sd.mp4?s=d4d7d89c9fed297041a578143a040e617bae1b25&profile_id=164" type="video/mp4">
                                </video>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <section>
            <div class="page section-7" id="sec7" @wheel="wheelMotion">
                <div class="page-outline">
                    <div class="section-box w-100">
                        <div id="page-title-7" class="page-title fade fade-1">Contact us</div>
                        <div class="row justify-content-between" style="flex-direction: row-reverse">
                            <div class="col-md-7 mb-5" id="map">
                                <!-- <img src="/static/img/main/sample1.jpg" id="contact-images" ref="contact-images" class="contact-images w-100" :class="{ 'on' : pageNow > 5 }"/> -->
                                <div id="contact-images" class="contact-images w-100" :class="{ 'on' : pageNow > 5 }">
                                    <GmapMap :options="map_options" :center="{lat:40.7521009, lng:-73.9870919}" map-type-id="terrain" style="width: 100%; height: 100%">
                                        <gmap-marker :key="i" v-for="(m,i) in markers" :visible.sync=m.visible :title="m.infoText" :position="m.position" :icon="m.icon" :clickable="true" @click="openMap(m,i)"></gmap-marker>
                                    </GmapMap>
                                </div>


                            </div>
                            
                            <div class="col-md-5">
                                <div id="contact-info" class="contact-info">
                                    <div class="fade fade-2 mb-3">CMYK+WHITE, Inc.</div>
                                    <div class="fade fade-2 mb-3">
                                        49 W 38th Street, 4th Floor.<br>
                                        New York NY, 10018
                                    </div>
                                    <div class="fade fade-2">
                                        T 212.302.1460
                                        <!-- <br>F 212.302.1497 -->
                                    </div>

                                    <div class="fade fade-3 mt-4">
                                        For any inquiries or questions,<br>please email us at<br>
                                        <u>info@cmykpluswhite.com</u>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div> 
        </section>

    </div>
</template>


<script>
import { EventBus }     	from '../event-bus.js'
import { Carousel, Slide }  from 'vue-carousel'

export default {
    data() {
        return {
            winW            : 0,
            xDown           : null,
            yDown           : null,
            keyMotion       : false,
            slideIdx        : 0,
            mainSlide       : 0,
            prevSlide       : 5,
            pageTarget      : 1,
            pageNow         : 1,
            pageTimeline    : 3,
            pageTotal       : 7,
            pageJump        : false,
            duration        : 1000,
            gap             : 0,
            gapWidth        : 80,
            positions       : [],
            peoples         : [
                {
                    name    : 'Eunsun Lee',
                    position: 'Creative Director',
                    direct  : 'President',
                },{
                    name    : 'Yongsin Lee',
                    position: 'Art Director',
                    direct  : 'Vice President',
                },{
                    name    : 'Natalia Herrera',
                    position: 'Associate Art Director',
                    direct  : '',
                },{
                    name    : 'Katerina Karaev',
                    position: 'Senior Graphic Designer',
                    direct  : '',
                },{
                    name    : 'Gino Real',
                    position: 'Graphic Designer',
                    direct  : '',
                },{
                    name    : 'Robin Jang',
                    position: 'Graphic Designer',
                    direct  : '',
                },{
                    name    : 'Alena Savchenko',
                    position: 'Graphic Designer',
                    direct  : '',
                },{
                    name    : 'Jeong Ahn',
                    position: 'Graphic Designer',
                    direct  : '',
                },{
                    name    : 'Javier Pacheco',
                    position: 'Motion Designer',
                    direct  : '',
                },{
                    name    : 'Margaret Choi',
                    position: 'Motion Designer',
                    direct  : '',
                },{
                    name    : 'Yirui Tian',
                    position: 'Motion Designer',
                    direct  : '',
                },{
                    name    : 'Jaedon Lee',
                    position: 'Developer',
                    direct  : '',
                },{
                    name    : 'Yohan Park',
                    position: 'Developer',
                    direct  : '',
                },{
                    name    : 'Jennifer Lee',
                    position: '',
                    direct  : '',
                },
            ],
            map_options         : { 
                zoom        : 14,
                disableDefaultUI: true,
                center      : {
                    lat     :40.7521009, 
                    lng     :-73.9870919
                },
                styles      : [
                    {
                        "featureType": "all",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "weight": "2.00"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#9c9c9c"
                            }
                        ]
                    },
                    {
                        "featureType": "all",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "all",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 45
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#7b7b7b"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "all",
                        "stylers": [
                            {
                                "color": "#46bcec"
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#d3d3d3"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#070707"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    }
                ]
            },
            markers: [
                {
                    position: {
                        lat: 40.752113, 
                        lng: -73.984907
                    },
                    icon: {
                        url: 'https://cmykpluswhite.s3.amazonaws.com/Website_Images/map-pin.png'
                    },
                    infoText: 'CMYK+WHITE'
                }, 
            ]
        }
    },
    components: {
        Carousel,
        Slide
    },
    created () {
        EventBus.$on('menu', (pg) => {
            setTimeout(() => {
                this.pageTarget = pg
            }, 300)
        })
        
    },
    mounted() {
        this.init()
        this.directPage()
        this.mainSlide = 1

        const winW = document.body.clientWidth
        setTimeout(() => { EventBus.$emit('theme', 'white') }, 100)
    },
    beforeDestroy() {
        this.uninit()
    },
    methods: {
        init() {
            window.addEventListener('scroll',   this.mobileScroll)
            window.addEventListener('scroll',   this.mobileContact)
            window.addEventListener("resize",   this.resizeEvent)

            window.addEventListener('keydown',  this.mainHandler)

            this.getPosition()
            this.resizeEvent()

            // document.getElementById('typography-we-are').classList.add('on')
        },
        uninit() {
            const winW = document.body.clientWidth

            window.removeEventListener('scroll',    this.mobileScroll)
            window.removeEventListener('scroll',    this.mobileContact)
            window.removeEventListener("resize",    this.resizeEvent)

            window.removeEventListener('keydown',   this.mainHandler)

            EventBus.$off("menu")
        },
        resizeEvent() {
            const target = document.querySelector('#sec' + this.pageTarget)
            document.getElementById('scroll').scrollLeft = target.offsetLeft

            const winW = document.body.clientWidth
            if(winW > 1180) {
                this.gap = (document.body.clientWidth - 1180) / 2 + this.gapWidth
            }else{
                this.gap = this.gapWidth
            }

            var slide = document.querySelectorAll('.project .slide')
            slide.forEach((elem)=> {
                if(winW < 768) {
                    elem.style.left = '0'
                }else{
                    elem.style.left = '50%'
                }
            })
            
            if(this.pageNow > 2 && this.pageNow < (this.pageTimeline + 4)) document.getElementById('sec' + (Number(this.pageNow) + 1)).style.marginLeft = (this.gap * -1) + 'px'

            this.getPosition()
            this.mobileScroll()
            document.getElementById('page-shadow').removeAttribute('style')

            if(this.pageNow < (this.pageTimeline + 4)) {
                if(document.body.clientWidth >= 768) {
                    var sectionW
                    (winW > 1180) ? sectionW = 1180 : sectionW = winW - 50
                    document.getElementById('contact-images').style.transform = 'translateX(' + (( sectionW - document.getElementById('contact-images').offsetWidth ) * -1) + 'px)'
                }
            }
            
        },
        getPosition() {
            const pages = document.querySelectorAll('.page')
            
            this.positions = []
            pages.forEach((elem, index) => { 
                this.positions.push(elem.clientWidth * index)
            })
            this.reLocation()
        },
        reLocation() {
            let startLocation   = document.getElementById('scroll').scrollLeft,
                endLocation     = this.positions[this.pageTarget - 1],
                distance        = endLocation - startLocation,
                position        = startLocation + distance
            if(this.pageTarget == (this.pageTimeline + 4)) {
                if(document.body.clientWidth >= 768) {
                    var x = (document.body.clientWidth) / 2 - 81
                    document.getElementById('contact-images').style.transform = 'translateX(0)'
                }
            }
        },
        wheelMotion(e) {
            if(e.target.closest('#map')) return
            const winW = document.body.clientWidth
            if(winW < 768) return

            const target = document.querySelector('#sec' + this.pageTarget)
            const viewStart = document.getElementById('scroll').scrollLeft
            
            if (!this.pageJump) {
                var pageWidth           = target.scrollWidth
                var pageStart           = target.offsetLeft
                var pageStopPortion     = pageWidth / 2
                var viewWidth           = window.innerWidth

                var viewEnd             = viewStart + viewWidth
                var pageStartPart       = viewEnd - pageStart
                var pageEndPart         = pageStart + pageWidth - viewStart

                var canJumpDown         = pageStartPart >= 0
                var stopJumpDown        = pageStartPart > pageStopPortion

                var canJumpUp           = pageEndPart >= 0
                var stopJumpUp          = pageEndPart > pageStopPortion

                var scrollingForward    = e.deltaY > 0

                if (scrollingForward) {
                    if(this.pageTarget < (this.pageTimeline + 4)) {
                        this.pageTarget++
                    }
                }else if(this.pageTarget > 1){
                    this.pageTarget--
                }

                this.wheelMotionMotion()
            }
        },
        wheelMotionMotion() {
            const winW = document.body.clientWidth
            
            if(this.pageTarget > (this.pageTimeline - 1) && this.pageTarget < (this.pageTimeline + 4)) {
                document.querySelector('#sec' + this.pageTarget + ' .timeline').classList.add('on')
            }else if(this.pageTarget == (this.pageTimeline - 1)) {
                document.querySelector('#sec' + this.pageTimeline + ' .timeline').classList.remove('on')
            }
            
            if(this.pageTarget == (this.pageTimeline + 3)) document.querySelector('#sec' + (this.pageTimeline + 4)).classList.remove('on')
            if(this.pageTarget == (this.pageTimeline + 4)) document.querySelector('#sec' + (this.pageTimeline + 4)).classList.add('on')
        },
        goPage(pg) {
            if(pg == (this.pageTimeline + 4)) {
                document.querySelector('#sec' + (this.pageTimeline + 4)).classList.add('on')

                for(var i=4; i<(this.pageTimeline + 4); i++) {
                    document.querySelector('#sec' + i + ' .timeline').classList.add('on')
                }
            }

            this.pageTarget = pg
            this.pageJump = true

            let endLocation
            let distance
            let sectionW
            let people = document.getElementById('people')

            if(document.getElementById('scroll') == null) return
            const viewStart     = document.getElementById('scroll').scrollLeft
            const startLocation = viewStart
            const shadowElem    = document.getElementById('page-shadow')
            

            endLocation     = this.positions[this.pageTarget - 1]
            distance        = endLocation - startLocation

            let runAnimation
            let percentage, position
            let timeLapsed = 0
            let winW = document.body.clientWidth

            var stopAnimationIfRequired = (pos) => {
                if (pos == endLocation) {
                    cancelAnimationFrame(runAnimation)
                    this.pageJump = false
                }
            }

            if(this.pageTarget == 1) document.getElementById('typography-we-are').classList.add('on')
            if(this.pageTarget == (this.pageTimeline + 4)) {
                document.getElementById('sec3').style.marginLeft = 0 + 'px'
                document.getElementById('sec4').style.marginLeft = 0 + 'px'
                document.getElementById('sec5').style.marginLeft = 0 + 'px'
                document.getElementById('sec6').style.marginLeft = 0 + 'px'
                document.getElementById('sec7').style.marginLeft = 0 + 'px'
            }

            var animate = () => {
                timeLapsed += 16
                percentage = timeLapsed / this.duration
                if (percentage > 1) {
                    percentage  = 1
                    position    = endLocation
                    this.pageNow = this.pageTarget
                    
                    if(this.pageTarget > (this.pageTimeline - 1)) {
                        document.getElementById('sec' + this.pageTarget).style.marginLeft = '0px'
                    }
                    if(this.pageTarget > 1) {
                        document.getElementById('section-2-desc').classList.add('on')
                    }
                } else {
                    position    = startLocation + distance * this.easing(percentage)
                    var secTarget = document.getElementById('sec' + (Number(this.pageTarget) + 1))

                    if(this.pageTarget - this.pageNow > 0) {
                        if(this.pageTarget > 2) {
                            var x = (this.gap - (this.easing(percentage) * this.gap)) * -1
                            if(secTarget) secTarget.style.marginLeft = (this.gap * -1) + 'px'
                            if(winW > 767 && winW < 1200) {
                                if(secTarget) secTarget.style.marginLeft = 0 + 'px'  
                            }
                            if(this.pageTarget > 2) document.getElementById('sec' + (Number(this.pageTarget))).style.marginLeft = x + 'px'
                        }

                        if(this.pageTarget == (this.pageTimeline + 4)) {
                            if(winW >= 768) {
                                (winW > 1180) ? sectionW = 1180 : sectionW = winW - 50
                                document.getElementById('contact-images').style.transform = 'translateX(' + (this.easing(1 - percentage) * ( sectionW - document.getElementById('contact-images').offsetWidth ) * -1 ) + 'px)'
                            }
                        }
                    }else if(this.pageTarget - this.pageNow < 0){
                        if(this.pageTarget == (this.pageTimeline - 1)) {
                            var x = (this.easing(percentage) * this.gap) * -1
                            document.getElementById('sec' + (this.pageTimeline)).style.marginLeft = x + 'px'
                            if(winW > 767 && winW < 1200) {  
                                document.getElementById('sec' + (this.pageTimeline)).style.marginLeft = 0 + 'px'  
                                
                            } 
                        }
                        if(this.pageTarget > (this.pageTimeline - 1)) {
                            var x = (this.easing(percentage) * this.gap) * -1
                            document.getElementById('sec' + this.pageNow).style.marginLeft = x + 'px'
                        }

                        
                        if(this.pageTarget == (this.pageTimeline + 3)) {
                            if(winW >= 768) {
                                (winW > 1180) ? sectionW = 1180 : sectionW = winW - 50
                                document.getElementById('contact-images').style.transform = 'translateX(' + (this.easing(percentage) * ( sectionW - document.getElementById('contact-images').offsetWidth ) * -1) + 'px)'
                            }
                        }
                    }
                    
                }

                shadowElem.style.visibility = 'visible'
                shadowElem.style.opacity = this.easing(percentage) / 3

                var slide = document.querySelectorAll('.project .slide')
                slide.forEach((elem)=> {
                    elem.style.left = 50 + (this.easing(percentage) * 10) + '%'
                })

                if(percentage > 0.1) {
                    if(this.pageTarget == 1){
                        shadowElem.style.opacity = (1 - this.easing(percentage)) / 3
                        var slide = document.querySelectorAll('.project .slide')
                        slide.forEach((elem)=> {
                            elem.style.left = 50 + ((1 - this.easing(percentage)) * 10) + '%'
                        })
                    }

                    if(percentage == 1) document.getElementById('page-shadow').removeAttribute('style')

                    if(this.pageTarget == (this.pageTimeline + 4)) {
                        if(winW >= 768) {
                            (winW > 1180) ? sectionW = 1180 : sectionW = winW - 50
                            document.getElementById('contact-images').style.transform = 'translateX(' + (this.easing(1 - percentage) * ( sectionW - document.getElementById('contact-images').offsetWidth ) * -1 ) + 'px)'
                        }
                    }
                }
                document.getElementById('scroll').scrollLeft = position
                runAnimation = requestAnimationFrame(animate)
                stopAnimationIfRequired(position)
            }

            // Loop the animation function
            runAnimation = requestAnimationFrame(animate)

        },
        directPage(rote) {
            const route = this.$route.name
            
            if( route == 'main-contact' ) {
                this.pageTarget = (this.pageTimeline + 4)
            }else if( route == 'who-we-are' ) {
                this.pageTarget = 2
            }else if( route == 'main' ) {
                this.pageTarget = 1
            }
        },
        easing(progress) {
            return progress < 0.5 ? 4 * progress * progress * progress : (progress - 1) * (2 * progress - 2) * (2 * progress - 2) + 1
        },
        mobileScroll() {
            const winW = document.body.clientWidth
            if(winW < 768) {
                const header        = document.getElementById('header')
                const shadowElem    = document.getElementById('page-shadow')
                const sec2          = document.getElementById('sec2')
                const project       = document.getElementById('project')

                var top             = window.scrollY
                var sec1            = document.getElementById('sec1').offsetHeight
                
                if(top > sec1) {
                    header.classList.add('bg-active')
                }else{
                    header.classList.remove('bg-active')
                    shadowElem.style.opacity = top/sec1 *.4
                }


                if(window.scrollY > 0 ) {
                    project.style.transform     = 'translateY(' + (window.scrollY) * -1 + 'px)'
                    sec2.style.paddingTop       = (window.scrollY) / 7 + 30 + 'px'
                }else{
                    project.style.transform     = 'translateY(0)'
                    sec2.style.paddingTop       = '30px'
                }
            }
        },
        mobileContact(e) {
            const winW = document.body.clientWidth
            if(winW < 768) {
                var sec8 = document.getElementById('sec' + (this.pageTimeline + 4))
                var image = document.querySelector('.contact-images')
                var info = document.querySelector('.contact-info')
                var winY = window.scrollY
                var screenH = screen.height
                var gap = 250

                if(winY + screenH > (sec8.offsetTop))  {
                    var y = gap * (winY + screenH - sec8.offsetTop) / screenH - gap
                    if(y > 0) y = 0
                    sec8.style.transform = 'translateY(' + y + 'px)'
                    var per = (Math.round(Math.abs(y)) / gap)
                    image.style.transform = 'translateY(' + (( per * -100 ) + 20) + 'px)'
                }
                (winY > screenH - 300) ? EventBus.$emit('theme', 'black') : this.themeChange(this.pageNow)
            }
        },
        moveWhoweare() {
            const sec2 = document.getElementById('sec2')

            var smoothScrollFeature = 'scrollBehavior' in document.documentElement.style
            if(smoothScrollFeature) {
                window.scrollTo({
                    left    : 0, 
                    top     : sec2.offsetTop,
                    behavior: 'smooth'
                })
            }else{
                var now = window.scrollY
                var i = 0
                var y = 0
                
                var int = setInterval(() => {
                    i++
                    if(now > sec2.offsetTop) {
                        y =  sec2.offsetTop + ((now - sec2.offsetTop) * this.easing((100-i) / 100))
                    }else{
                        y =  now + ((sec2.offsetTop - now) * this.easing(i / 100))
                    }
                    window.scroll(0, y)
                    if (i == 100) clearInterval(int)
                }, 5)
            }
        },
        mainHandler(e) {
            if(e.keyCode == 39) {
                this.mainHandlerMotion('right')
            }else if(e.keyCode == 37) {
                this.mainHandlerMotion('left')
            }
        },
        mainHandlerMotion(type) {
            if(this.keyMotion) return
            this.prevSlide = this.mainSlide
            const pgNum = this.$refs['carousel'].currentPage
            if(type == 'right') {
                if(pgNum < 4) {
                    this.keyMotion = true
                    this.slideIdx = pgNum + 1
                    this.mainSlide++
                    this.motion()
                }
            }else if(pgNum > 0){
                if(pgNum > 0) {
                    this.keyMotion = true
                    this.slideIdx = pgNum - 1
                    this.mainSlide--
                    this.motion()
                }
            }
        },
        slideStart() {
            
        },
        slideEnd() {
            this.keyMotion = false
        },
        motion() {
            if (document.getElementById('page_spin').classList.contains('run2')) {
                document.getElementById('page_spin').classList.remove('run2')
                document.getElementById('page_spin').classList.add('run1')
            }else{
                document.getElementById('page_spin').classList.remove('run1')
                document.getElementById('page_spin').classList.add('run2')
            }
        },
        themeChange(pg) {
            if( (this.mainSlide == 1 && pg == 1) || (this.mainSlide == 4 && pg == 1) || (this.mainSlide == 5 && pg == 1) ) {
                EventBus.$emit('theme', 'white')
            }else{
                setTimeout(() => {
                    EventBus.$emit('theme', 'black')
                }, 300)
                
            }
        },
        openMap() {
            window.open('https://www.google.com/maps/place/CMYK%2BWHITE+INC/@40.7521009,-73.9849032,15z/data=!4m2!3m1!1s0x0:0xe78ad8ab9659f9?sa=X&ved=2ahUKEwjsyI7q6MDqAhX0mXIEHdU-DB0Q_BIwG3oECA8QCA');
        },
        getTouches(evt) {
            return evt.touches 
        },
        slideChange() {
            const pgNum = this.$refs['carousel'].currentPage
            this.mainSlide = pgNum + 1
            this.themeChange(this.pageNow)
        },
    },
	watch: {
        pageTarget(pg) {
            if(!pg) return
            const winW = document.body.clientWidth
            if(winW < 768) {
                if(pg == 2) {
                    this.moveWhoweare()
                }
            }else{
                this.goPage(pg)
            }
            EventBus.$emit('targetPage', pg)
            
            this.themeChange(pg)

            // if(pg == 2) {
            //     const video = document.querySelector('.section-2 video')
            //     console.log(video)
            //     if(video) video.play()
            // }
        },
        mainSlide(v) {
            // if(v == 2) return

            // const winW = document.body.clientWidth
            // var video = document.getElementById('main_video_' + v)
            // if(video.src) return

            // if(winW < 768) {
            //     video.setAttribute("src", this.videos_mobile[v-1])
            //     video.play()
            // }else{
            //     video.setAttribute("src", this.videos_web[v-1])
            //     video.play()
            // }
        },
	},
    filters: {
    },
}
</script>


<style lang="scss" scoped>
    @import '../assets/scss/pages/main.scss';
</style>


// WEBPACK FOOTER //
// src/pages/main.vue